export const editorStyles = {
  '.editor-text-bold': {
    fontWeight: 'bold',
  },
  '.editor-text-italic': {
    fontStyle: 'italic',
  },
  '.editor-text-underline': {
    textDecoration: 'underline',
  },
  '.editor-text-strikethrough': {
    textDecoration: 'line-through',
  },
  '.editor-text-code': {
    backgroundColor: '#f3f3f3',
    padding: '2px 4px',
    borderRadius: '2px',
    fontFamily: 'monospace',
    fontSize: '0.9em',
  },
  '.redacted-text': {
    backgroundColor: '#3e8ed0',
    color: 'white',
    padding: '2px 4px',
    borderRadius: '3px',
    fontWeight: 'bold',
  },
  '.redacted-input': {
    backgroundColor: '#f5f5f5',
    border: '2px dashed #3e8ed0',
    borderRadius: '3px',
    padding: '2px 4px',
    minWidth: '80px',
    display: 'inline-block',
  },
  '.editor-heading-h1': {
    fontSize: '2em',
    fontWeight: 'bold',
    margin: '0.67em 0',
    lineHeight: '1.2',
  },
  '.editor-heading-h2': {
    fontSize: '1.5em',
    fontWeight: 'bold',
    margin: '0.83em 0',
    lineHeight: '1.2',
  },
  '.editor-heading-h3': {
    fontSize: '1.17em',
    fontWeight: 'bold',
    margin: '1em 0',
    lineHeight: '1.2',
  },
  '.editor-list-ol': {
    listStyleType: 'decimal',
    margin: '1em 0',
    paddingLeft: '40px',
  },
  '.editor-list-ul': {
    listStyleType: 'disc',
    margin: '1em 0',
    paddingLeft: '40px',
  },
  '.editor-listitem': {
    margin: '0.25em 0',
  },
  '.editor-quote': {
    borderLeft: '4px solid #ccc',
    margin: '1em 0',
    paddingLeft: '1em',
    fontStyle: 'italic',
    color: '#666',
  },
  '.editor-link': {
    color: '#1976d2',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  '.editor-code': {
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '1em',
    fontFamily: 'monospace',
    whiteSpace: 'pre',
    overflowX: 'auto',
    margin: '1em 0',
  },
};
